import { createKiddoAxios } from "./httpClient";

let apiInstance = null;

const getAPIInstance = async () => {
  if (!apiInstance) {
    apiInstance = await createKiddoAxios({
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  return apiInstance;
};

export const updateProfileWithPhoto = async (formData) => {
  const API = await getAPIInstance();
  const response = await API.post("/Insert/UpdateProfileWithPhoto", formData);
  return response.data;
};
